import { createTransform } from "redux-persist";

const replacer = (key:any, value:any) => value instanceof Date ? value.toISOString() : value
const reviver = (key:any, value:any) =>
  (typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/))
    ? new Date(value)
    : value

const encode = (toDeshydrate:any) => JSON.stringify(toDeshydrate, replacer)
const decode = (toRehydrate: any) => JSON.parse(toRehydrate, reviver)

export const dateTransform = createTransform(encode, decode)